<script lang="ts" setup generic="T">
import LeftArrowIcon from "~/assets/icons/arrows/24/arrow-left.svg?component";
import RightArrowIcon from "~/assets/icons/arrows/24/arrow-right.svg?component";
import SliderPagination from '~/components/ui/slider/sliderElements/SliderPagination.vue';
// import {Navigation, SwiperAutoplay} from 'swiper/modules'
import {Navigation, Autoplay} from 'swiper/modules'
import type {IMonitorSize} from "~/shared/interfaces/composables";
import type {SwiperOptions, Swiper} from 'swiper/types';
import type { IBanner } from "~/shared/interfaces/banners";

withDefaults(defineProps<{
  content: IBanner[]
  sliderName: string
  slidesCount?: number
  paginationBreakpoint?: number
  sizes?: IMonitorSize | null
  sliderBreakpoints?: SwiperOptions['breakpoints']
  sliderAutoplay?: SwiperOptions['autoplay']
  sliderSlidesPerView?: number
  sliderSpaceBetween?: number
  hasPagination?: boolean
  hasControls?: boolean
  sliderLoop?: SwiperOptions['loop']

}>(), {
  sliderName: 'Slider',
  paginationBreakpoint: 2000000,
  hasPagination: false,
})

let activeSlide = ref(0);
let swiperSlider = ref<Swiper | null>(null);
let next = ref<HTMLElement | null>(null)
let prev = ref<HTMLElement | null>(null)

function activeSlideChanged(slider: Swiper) {
  activeSlide.value = slider.realIndex;
}

</script>

<template>
  <div class="slider__container">
    <Swiper
      class="slider"
      ref="swiperSlider"
      :class="!hasPagination && 'withoutPagination'"
      :modules="[Autoplay, Navigation]"
      :navigation="{
        prevEl : prev,
        nextEl : next,
        disabledClass : 'buttonDisabled'
      }"
      :autoplay="sliderAutoplay"
      :breakpoints="sliderBreakpoints"
      :space-between="sliderSpaceBetween"
      @activeIndexChange="activeSlideChanged"
      :loop="sliderLoop"
      :slides-per-view="sliderSlidesPerView"
      :slides-per-group="2"
    >
      <SwiperSlide
        v-for="(contentItem, index) in content"
        :key="index"
        class="banners__slider-slide"
      >
        <slot
          name="contentItem"
          :contentItem="contentItem"
        />
      </SwiperSlide>
      <SliderPagination
        class="slider__pagination"
        v-if="hasPagination && sizes && sizes.browserWidth < paginationBreakpoint"
        :current-slide="activeSlide"
        :slides-count="slidesCount"
      />
    </Swiper>
    <div v-if="hasControls" class="slider__controls">
      <button class="slider__controls-left" ref="prev">
        <LeftArrowIcon/>
      </button>
      <button class="slider__controls-right" ref="next">
        <RightArrowIcon/>
      </button>
    </div>
  </div>

</template>

<style lang="scss" scoped>
.slider {
  padding-bottom: 24px;

  &.withoutPagination {
    padding: 0;
  }

  &__container {
    position: relative;
    width: 100%;
  }

  .slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    /* Занимает 80% от контейнера */
  }

  .swiper-wrapper {
    height: auto;
  }

  &__controls {

    &-left,
    &-right {
      transition: visibility ease 0.3s, opacity ease 0.3s;
      z-index: 10;
      top: 50%;
      transform: translateY(-50%);
      padding: 8px;
      border-radius: 50%;
      height: 40px;
      background-color: $bg_page;
      box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);

      @include md-breakpoint {
        display: none;
      }

      @include mf-xs-breakpoint {
        &:hover:not(:active, .active, .disabled) {
          @include mf-breakpoint {
            color: $control-content_orange-hover;
            @include btn-svg-color($control-content_orange-hover);
          }
        }
      }

      &.buttonDisabled {
        visibility: hidden;
        opacity: 0;
      }
    }

    &-left {
      position: absolute;
      left: -20px;
    }

    &-right {
      position: absolute;
      right: -20px;
    }
  }

  &.slider_pagination {
    padding-bottom: 24px;
  }

  &__pagination {
    left: 50%;
    bottom: 8px;
  }
}
</style>
